// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"6c6d196a","399":"6c6d196a","418":"038737bf","524":"d1721bfe","605":"038737bf","645":"038737bf","679":"6c6d196a","969":"6c6d196a"}[chunkId] + ".chunk.css";
};